import { type UTCDate } from '@date-fns/utc';
import { startOfHour } from 'date-fns';
import { getAllStrategyStats } from '@/shared/graphql/reporting/strategies';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { getStrategyFromReportingFragment } from '@/shared/utils/strategies';

export const useStrategyStats = (
  startDate: UTCDate,
  endDate: UTCDate,
  ownerAccountSs58Id?: string,
) => {
  const { data, isLoading } = useGqlQuery(getAllStrategyStats, {
    context: { clientName: 'reportingService' },
    variables: {
      startTime: startOfHour(startDate).toISOString(),
      endTime: startOfHour(endDate).toISOString(),
      ownerAccountSs58Id,
    },
    refetchInterval: 60_000,
  });

  return {
    isLoading,
    volumeFilled: Number(data?.stats?.aggregates?.sum?.totalFilledVolumeValueUsd ?? 0),
    pnl: Number(data?.stats?.aggregates?.sum?.totalPnlValueUsd ?? 0),
    closedStrategies: data?.closedStrategies?.nodes.map(getStrategyFromReportingFragment) ?? [],
  };
};
